import { render, staticRenderFns } from "./topbar-start.vue?vue&type=template&id=79499723"
import script from "./topbar-start.vue?vue&type=script&lang=js"
export * from "./topbar-start.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-start.vue
// module id = 3Te7
// module chunks = 0